<template>
	<v-container grid-list-md>
		<v-form>
			<v-card>
				<v-card-title primary-title>
					<v-btn
						icon
						@click="
							$inertia.visit(
								$route('tenant.reservation_sessions.index', {
									tenant: $page.props.tenant.id,
									outlet: outlet.uuid,
								})
							)
						"
					>
						<v-icon>mdi-arrow-left</v-icon>
					</v-btn>
					{{ $t("title.edit_reservation_session") }}
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-layout row wrap>
						<v-flex xs12>
							<ValidationProvider
								name="name"
								rules="required"
								v-slot="{ errors, valid }"
							>
								<v-text-field
									v-model="item.name"
									:label="$t('Name')"
									data-vv-name="name"
									:error-messages="errors"
									:append-icon="valid ? 'mdi-check' : null"
								></v-text-field>
							</ValidationProvider>
						</v-flex>
						<v-flex xs12>
							<ValidationProvider
								name="description"
								rules=""
								v-slot="{ errors, valid }"
							>
								<v-textarea
									v-model="item.description"
									:label="$t('Description')"
									data-vv-name="description"
									:error-messages="errors"
									:append-icon="valid ? 'mdi-check' : null"
								></v-textarea>
							</ValidationProvider>
						</v-flex>
						<v-flex xs12>
							<v-switch
								v-model="item.active"
								:label="$t('Active')"
								data-vv-name="active"
								filled
							></v-switch>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						@click.native="submit()"
						:loading="item.processing"
					>
						<v-icon left>mdi-content-save</v-icon>
						{{ $t("Save") }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-container>
</template>

<script>
export default {
	props: ["data", "outlet"],
	data() {
		return {
			item: this.$inertia.form(this.data),
		};
	},
	methods: {
		submit() {
			this.item.put(
				this.$route("tenant.reservation_sessions.update", {
					tenant: this.$page.props.tenant.id,
					reservation_session: this.item.uuid,
					outlet: this.outlet.uuid,
				})
			);
		},
	},
};
</script>
